import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "align-center" }
const _hoisted_4 = { class: "align-center" }
const _hoisted_5 = { class: "align-center" }
const _hoisted_6 = {
  key: 0,
  class: "align-center"
}
const _hoisted_7 = { class: "align-center" }
const _hoisted_8 = { class: "align-center" }
const _hoisted_9 = { class: "align-right fit-content" }
const _hoisted_10 = { class: "align-center" }
const _hoisted_11 = { class: "align-center" }
const _hoisted_12 = {
  key: 0,
  class: "align-center"
}
const _hoisted_13 = { class: "align-center" }
const _hoisted_14 = { class: "align-center" }
const _hoisted_15 = { class: "align-center" }

import { PropType, computed } from 'vue'

import { StandingsRundownRow } from '@/store/public/leagues.types'
import { formatFloat, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueRundownTable',
  props: {
  rows: {
    type: Array as PropType<StandingsRundownRow[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const hasHandicap = computed<boolean>(
  () =>
    props.rows.filter((r) => r.total_raw_score !== r.total_score).length > 0,
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", { class: "fit-content" }, null, -1)),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.bowler')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('leagues.labels.team')), 1),
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('leagues.labels.total')), 1),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('leagues.labels.series-played')), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('leagues.labels.average')), 1),
          (hasHandicap.value)
            ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(_ctx.$t('leagues.labels.cleanAverage')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('leagues.labels.best')), 1),
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('leagues.labels.bonus')), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `rundown-row-${i}`
          }, [
            _createElementVNode("td", _hoisted_9, _toDisplayString(i + 1) + ".", 1),
            _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(row.bowler_full_name)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(formatValue)(row.team_name)), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(formatFloat)(row.total_score, 0)), 1),
            _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatFloat)(row.game_count, 0)), 1),
            (hasHandicap.value)
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_unref(formatFloat)(row.average_score, 2)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(formatFloat)(row.average_raw_score, 2)), 1),
            _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatFloat)(row.best_raw_score, 0)), 1),
            _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatFloat)(row.total_personal_bonuses, 0)), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})